import { Record } from 'immutable';
import {
  RECEIVE_TRADE_HISTORY_DATA,
  REQUEST_TRADE_HISTORY_DATA
} from './actions';


const State = Record({
 fetchingTradeHistoryData : false,
 tradeHistoryData: null
});

export default (state = new State(), action) => {
  switch (action.type) {

    case REQUEST_TRADE_HISTORY_DATA:
      return state.withMutations(s => {
        s.setIn(['fetchingTradeHistoryData'], true);
        s.deleteIn(['tradeHistoryData']);
      });
    case RECEIVE_TRADE_HISTORY_DATA:
      return state.withMutations(s => {
        s.setIn(['fetchingTradeHistoryData'], false);
        s.setIn(['tradeHistoryData'], action.data);
      });

    default:
      return state;
  }
};
